import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class TwilioService {


    private baseUrl = `${environment.WebhookUrl}`;;
    constructor(private http: HttpClient) { }

    makePayment(sip: string): Observable<any> {
        var apiUrl = `${this.baseUrl}${environment.TwilStartUrl}`;

        const body = {
            "CallSid": sip
        };

        return this.http.post(apiUrl, body);
    }

    captureCard(sip: string, pksip: string, captureType: string, completeOrCancel: any = null) {
        var apiUrl = `${this.baseUrl}${environment.TwilCaptureUrl}`;
        const body: any = {
            "CallSid": sip,
            "PkSid": pksip
        };
        if (!completeOrCancel) {
            body.CaptureType = captureType;
        }else{
            body.Status = completeOrCancel;
        }
        return this.http.post(apiUrl, body);
    }
    generateRandomNumber(): number {
        const timestamp = Date.now();
        const randomNumber = Math.random() * timestamp;
        return Math.floor(randomNumber);
    }
}
